import {
    ADMIN_PROFILE_INFORMATION_REQUEST,
    ADMIN_PROFILE_INFORMATION_REQUEST_SUCCESS,
    ADMIN_PROFILE_INFORMATION_REQUEST_FAIL
} from './adminConstants'

export const adminProfileInformationReducer = (state = {
    address: '',
    fullName: '',
    imageURL: '',
    mobileNumber: '',
    information: {},
}, action) => {
    switch (action.type) {
        case ADMIN_PROFILE_INFORMATION_REQUEST:
            return {
                loading: true,
                ...state
            }
        case ADMIN_PROFILE_INFORMATION_REQUEST_SUCCESS:
            return {
                loading: false,
                address: action.payload.address,
                fullName: action.payload.fullName,
                mobileNumber: action.payload.mobileNumber,
                imageURL: action.payload.imageURL,
                information: action.payload.information,
            }
        case ADMIN_PROFILE_INFORMATION_REQUEST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}